import { OVERVIEW_LABELS } from '@src/utils/kpi';

export const getKpiSelectOptions = (kpiList: any[]) => {
  return kpiList.map((kpi: any) => ({
    value: kpi.kpiID,
    label: kpi.kpiName,
  }));
};

export const validateKPIConfigData = (kpiData, kpiList) => {
  const kpiName = kpiData.kpiName;
  const filteredConfig = kpiList.filter((item) => item.kpiID !== kpiData.kpiID);
  const existingKpiNames = filteredConfig.map((item) => item.kpiName.toLowerCase());
  if (!kpiName) {
    return {
      status: false,
      errorMessage: OVERVIEW_LABELS.ERROR_KPI_EMPTY,
    };
  }
  if (kpiName.length > 64) {
    return {
      status: false,
      errorMessage: OVERVIEW_LABELS.ERROR_KPI_MAX_LENGTH,
    };
  }
  if (kpiName && existingKpiNames.includes(kpiName.toLowerCase())) {
    return {
      status: false,
      errorMessage: OVERVIEW_LABELS.ERROR_KPI_DUPLICATE,
    };
  }
  return {
    status: true,
    errorMessage: '',
  };
};
